import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumQcProbeProvider implements BaseEnumType {
  private static allValues: EnumQcProbeProvider[] = []; // make sure this is top-most
  
  public static none = new EnumQcProbeProvider(0, "None", "enum_qc_probe_provider_none");
  public static plaato = new EnumQcProbeProvider(1, "Plaato", "enum_qc_probe_provider_plaato");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumQcProbeProvider.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumQcProbeProvider.none; }
  public isPlaato() { return this === EnumQcProbeProvider.plaato; }

  public static getValues(): readonly EnumQcProbeProvider[] {
    return EnumQcProbeProvider.allValues;
  }

  public static getValuesExcept0(): readonly EnumQcProbeProvider[] {
    return EnumQcProbeProvider.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumQcProbeProvider {
    const found = EnumQcProbeProvider.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumQcProbeProvider - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumQcProbeProvider): EnumQcProbeProvider {
    const found = name ? EnumQcProbeProvider.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumQcProbeProvider - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumQcProbeProvider>): boolean {
    return this.key === other?.key;
  }
}